<template>
    <section>
        <Header title="Good Practices" show-back-button></Header>
        <v-container class="pt-0 pt-md-4">
            <p v-if="isLoading" class="text-center my-7"><v-icon large color="primary">fal fa-spinner-third fa-spin</v-icon></p>
            <v-breadcrumbs :items="breadcrumbs" class="px-0"></v-breadcrumbs>
            <v-row v-if="!isLoading">
                <v-col class="col-12 col-md-8 col-lg-9">
                    <GoodPracticeList></GoodPracticeList>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import Header from "@/components/layout/Header";
import GoodPracticeList from "@/components/good-practice/GoodPracticeList";

export default {
    name: 'GoodPractices',
    components: {
        GoodPracticeList,
        Header,
    },
    data: () => ({
        isLoading: true,
        breadcrumbs: [
            {
                text: 'Dashboard',
                disabled: false,
                exact: true,
                to: {
                    name: 'Home'
                }
            },
            {
                text: 'Good Practices',
                disabled: true,
                exact: true,
                to: {
                    name: 'GoodPractices'
                }
            }
        ],
    }),
    mounted() {
        this.$store.dispatch('goodPractice/updateGoodPractices')
            .catch(e => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', {color: 'error', text: 'Good practices konden niet worden opgehaald'});
            })
            .finally(() => {
                this.isLoading = false;
            });
    },
}
</script>
